import { Component, OnInit } from '@angular/core';
import { IdleService } from 'src/app/core/services/idle.service';
import { TimeoutDialogComponent } from './core/components/timeout-dialog/timeout-dialog.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  title = 'mondelez-client';
  private dialogRef;

  constructor(private idleService: IdleService, public dialog: MatDialog) {}

  ngOnInit(): void {
    // user inactivity warning
    this.idleService.onTimeoutWarning$.subscribe((flag) => {
      // close previous dialog
      this.dialog?.closeAll();
      this.dialogRef = this.dialog.open(TimeoutDialogComponent, {
        width: '40vw',
        maxWidth: '400px',
        height: '50vh',
        maxHeight: '280px',
        disableClose: true,
        position: { top: '5%' },
        data: { flag },
      });
      this.dialogRef.afterClosed().subscribe((res) => {
        if (res === true) {
          this.idleService.startWatching(); // User chosse to stay
        } else {
          this.idleService.onAutoLogout$.next(null);
        }
      });
    });
  }
}
